/**
 * Turn a pasted list or an uploaded CSV into identifiers to match against the
 * school's students.
 *
 * One identifier per line: the email if the line has one (a CSV row is usually
 * "name,email,…"), otherwise the first cell, which may be a student id or a
 * bare email list. A header row matches nothing and is dropped by the server's
 * report, but obvious headers are skipped here so they are not listed as
 * "not found".
 */

const HEADERS = new Set(['email', 'e-mail', 'email address', 'student id', 'student_id', 'id', 'uid', 'name']);

export function parseRosterIdentifiers(text: string, max = 500): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const line of text.split(/\r?\n/)) {
    const cells = line
      .split(/[,;\t]/)
      .map((c) => c.trim().replace(/^["']|["']$/g, '').trim())
      .filter(Boolean);
    if (cells.length === 0) continue;
    // A line of bare emails ("a@x, b@y") yields each of them.
    const emails = cells.filter((c) => c.includes('@'));
    const picks = emails.length ? emails : [cells[0]];
    for (const pick of picks) {
      const key = pick.toLowerCase();
      if (HEADERS.has(key) || seen.has(key)) continue;
      seen.add(key);
      out.push(pick);
      if (out.length >= max) return out;
    }
  }
  return out;
}
